<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Events List</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input v-if="!reorderMode" type="text" class="form-control mb-3" placeholder="Search in events..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="d-flex align-items-center mb-3">
          <button class="procricket-btn reorder-btn" :class="{ 'is-active': reorderMode }" :disabled="savingOrder" @click="toggleReorderMode">
            <span class="reorder-btn__icon">{{ reorderMode ? '✓' : '≡' }}</span>
            {{ reorderMode ? 'Done ordering' : 'Reorder Events' }}
          </button>
          <span v-if="reorderMode" class="reorder-hint">Drag rows to reorder. Saved when you click Done ordering.</span>
          <span v-else-if="savingOrder" class="reorder-hint">Saving order...</span>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th v-if="reorderMode" style="width: 34px;"></th>
              <th class="col-1" @click="toggleSort('eventId')">Event Id</th>
              <th class="col-1" @click="toggleSort('firstMatcher')">First Matcher</th>
              <th class="col-1" @click="toggleSort('secondMatcher')">Second Matcher</th>
              <th class="col-1" @click="toggleSort('league')">League</th>
              <th class="col-1" @click="toggleSort('leagueId')">League Id</th>
              <th class="col-1" @click="toggleSort('orderNumber')">Order Number</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <Draggable
                v-if="reorderMode"
                tag="tbody"
                v-model="reorderList"
                item-key="eventId"
                :animation="150"
                ghost-class="drag-ghost"
                chosen-class="drag-chosen"
                drag-class="drag-drag"
            >
              <template #item="{ element: config }">
                <tr class="reorder-row">
                  <td style="width: 34px;"><span class="drag-handle" title="Drag to reorder">⋮⋮</span></td>
                  <td class="col-1 text-truncate">{{ config.eventId }}</td>
                  <td class="col-1 text-truncate">{{ truncateText(config.firstMatcher, 30) }}</td>
                  <td class="col-1 text-truncate">{{ truncateText(config.secondMatcher, 30) }}</td>
                  <td class="col-1 text-truncate">{{ truncateText(config.league, 30) }}</td>
                  <td class="col-1 text-truncate">{{ config.leagueId }}</td>
                  <td class="col-1 text-truncate">{{ config.orderNumber }}</td>
                  <td class="col-1 text-truncate">{{ config.application }}</td>
                  <td class="col-1 text-truncate">{{ config.status }}</td>
                  <td class="col-1 text-truncate">{{ config.active }}</td>
                  <td class="col-1"></td>
                </tr>
              </template>
            </Draggable>
            <tbody v-else>
            <tr v-for="config in sortData" :key="config.eventId">
              <td class="col-1 text-truncate" v-html="truncateText(config.eventId, 30)"  @click="selectText" :data-text="config.eventId" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.firstMatcher, 30)"  @click="selectText" :data-text="config.firstMatcher" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.secondMatcher, 30)" @click="selectText" :data-text="config.secondMatcher"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.league, 30)" @click="selectText" :data-text="config.league"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.leagueId, 30)" @click="selectText" :data-text="config.leagueId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.orderNumber, 30)" @click="selectText" :data-text="config.orderNumber"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.status, 30)" @click="selectText" :data-text="config.status"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'EventEdit', params: { id: config.eventId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";
import Draggable from "vuedraggable";

export default {
  name: "EventsList",
  components: {
    Header,
    Draggable,
  },
  data() {
    return {
      searchText: '',
      EventsList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
      selectedApp: '',
      reorderMode: false,
      reorderList: [],
      reorderBeforeMap: null,
      savingOrder: false
    };
  },
  computed: {
    filteredEventsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.EventsList.filter((config) => {
        return (
            (config.eventId && config.eventId.toString().includes(search)) ||
            (config.firstMatcher && config.firstMatcher.toString().toLowerCase().includes(search)) ||
            (config.secondMatcher && config.secondMatcher.toString().toLowerCase().includes(search)) ||
            (config.league && config.league.toString().toLowerCase().includes(search)) ||
            (config.leagueId && config.leagueId.toString().toLowerCase().includes(search)) ||
            (config.orderNumber && config.orderNumber.toString().toLowerCase().includes(search)) ||
            (config.application && config.application.toString().toLowerCase().includes(search)) ||
            (config.status && config.status.toString().includes(search)) ||
            (config.active && config.active.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      //Sort the table to include only the elements that have the selected application
      if (this.selectedApp !== '') {
        filteredList = filteredList.filter(item => item.application === this.selectedApp);
      }
      return filteredList;
    },
    sortData() {
      return this.filteredEventsList;
    },
  },
  created() {
    this.doLoadEvents();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    const appCookie = Cookies.get('application');
    if (appCookie) {
      this.selectedApp = appCookie;
    }

    this.sortColumn = 'eventId';
  },
  methods: {
    doLoadEvents() {
      AdminService.getEventsList().then((data) => {
       this.EventsList = data;
      }).catch((error) => {
        console.error("Error loading events:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      if (text === undefined || text ===null) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    redirectToCreate() {
      this.$router.push({ name: 'EventCreate' }); // Navigate to the EventEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    // Order is per application: the selected app's events, by current orderNumber (no order last).
    // On Done (if anything moved), renumbers 1..n and saves the events whose number changed.
    async toggleReorderMode() {
      if (!this.reorderMode) {
        const byOrder = (e) => (e.orderNumber == null || e.orderNumber === '' ? Number.MAX_SAFE_INTEGER : Number(e.orderNumber));
        this.reorderList = this.EventsList
            .filter(e => this.selectedApp === '' || e.application === this.selectedApp)
            .slice()
            .sort((a, b) => byOrder(a) - byOrder(b));
        this.reorderBeforeMap = Object.fromEntries(this.reorderList.map((e, idx) => [String(e.eventId), idx]));
        this.reorderMode = true;
        return;
      }

      this.reorderMode = false;
      const before = this.reorderBeforeMap || {};
      const moved = this.reorderList.some((e, idx) => before[String(e.eventId)] !== idx);
      // Renumbered 1..n, so any event whose stored number differs is saved, not only the ones that moved.
      const updates = !moved ? [] : this.reorderList
          .map((e, idx) => ({ event: e, orderNumber: idx + 1 }))
          .filter(x => x.event.orderNumber == null || Number(x.event.orderNumber) !== x.orderNumber)
          .map(x => ({ ...x.event, orderNumber: x.orderNumber }));
      this.reorderBeforeMap = null;
      this.reorderList = [];
      if (!updates.length) return;

      this.savingOrder = true;
      try {
        for (const ev of updates) {
          await AdminService.updateEvent(ev);
        }
      } catch (err) {
        console.error("Failed updating reordered events:", err);
        alert(err?.message || "Failed to save new order.");
      } finally {
        this.savingOrder = false;
        this.doLoadEvents();
      }
    },
    toggleSort(column) {
      if (this.reorderMode) return;
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
};
</script>
<style src="../../assets/style.css">
</style>
